import { render } from "./largeIconButton.vue?vue&type=template&id=c7ea2b3c&scoped=true"
import script from "./largeIconButton.vue?vue&type=script&lang=js"
export * from "./largeIconButton.vue?vue&type=script&lang=js"

import "./largeIconButton.vue?vue&type=style&index=0&id=c7ea2b3c&lang=scss&scoped=true"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7ea2b3c"]])

export default __exports__